export const appusers = {
  appusersSearch: 'Suche'
}
